var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 31,
    viewBox: "0 0 25 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6087 7.1796V26.2013H8.69565V12.6914L22.8261 6.636L7.6087 0.114258V7.1796ZM9.78261 20.8827C10.6575 20.8065 11.5664 20.7665 12.5 20.7665C19.4031 20.7665 25 22.9567 25 25.6578C25 28.3589 19.4032 30.5491 12.5 30.5491C5.59683 30.5491 0 28.3589 0 25.6578C0 23.8034 2.6359 22.1905 6.52174 21.3611V24.3534C5.86205 24.6514 5.43478 25.124 5.43478 25.6578C5.43478 26.5577 6.65106 27.2882 8.15217 27.2882C9.65329 27.2882 10.8696 26.5577 10.8696 25.6578C10.8696 25.124 10.4423 24.6514 9.78261 24.3534V20.8827ZM16.8478 26.2013C17.7477 26.2013 18.4783 25.7143 18.4783 25.1143C18.4783 24.5143 17.7477 24.0274 16.8478 24.0274C15.948 24.0274 15.2174 24.5143 15.2174 25.1143C15.2174 25.7143 15.948 26.2013 16.8478 26.2013Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinsIcon);
export default __webpack_public_path__ + "static/media/PinsIcon.9c84fa51201f0e3f074d8fd380377840.svg";
export { ForwardRef as ReactComponent };